export default __webpack_public_path__ + "static/media/student.74e9519a.png";